import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M19 18v-6a3 3 0 0 0 -3 -3h-7","key":"svg-0"}],["path",{"d":"M13 13l-4 -4l4 -4m-5 8l-4 -4l4 -4","key":"svg-1"}]]

const IconCornerUpLeftDouble = createReactComponent('outline', 'corner-up-left-double', 'CornerUpLeftDouble', __iconNode);

export default IconCornerUpLeftDouble;